import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2069_3957)" }, [
      _createElementVNode("path", {
        fill: "#fff",
        "fill-opacity": ".52",
        d: "M8 7.407c0-.196-.09-.353-.196-.559L4.67.554C4.461.132 4.264 0 3.997 0c-.266 0-.457.132-.668.554L.19 6.848c-.1.21-.191.368-.191.564C0 7.775.282 8 .719 8l6.557-.005c.437 0 .724-.225.724-.588"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2069_3957" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h8v8H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }